import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { connectM } from "./redux/blockchain/blockchainActions";
import {
  connect,
  isConnected,
} from "./redux/stakeBlockchain/blockchainActions";
import {
  fetchData,
  stakedNFTS,
  totalStakeNFTS,
} from "./redux/stakeData/dataActions";
import { fetchDataM, hasApproved } from "./redux/data/dataActions2";
import { createAlchemyWeb3 } from "@alch/alchemy-web3";

import "./styles/stake.css";
var Web3 = require("web3");
const Web3Alc = createAlchemyWeb3(
  "https://eth-rinkeby.alchemyapi.io/v2/8AX5AP2TU6G45ctsOXNt8K4Fz_BkhhZG"
);
const Staking = () => {
  const dispatch = useDispatch();
  const blockchain = useSelector((state) => state.blockchain);
  const data = useSelector((state) => state.data);
  const [feedback, setFeedback] = useState("STAKE");
  const [claiming, setClaiming] = useState(false);
  const [staking, setStaking] = useState(false);
  const [unstaking, setUnstaking] = useState(false);
  const [hasStaked, setHasStaked] = useState(false);
  const [_stake, _unStake] = useState("STAKE");

  const account = blockchain.account;
  const [tokenId, setTokenId] = useState([]);
  const [CONFIG, SET_CONFIG] = useState({
    CONTRACT_ADDRESS: "0xb86A0bc5f2D0D72c3327c01f88BC5e4D70D80148",
    SCAN_LINK: "",
    NETWORK: {
      NAME: "",
      SYMBOL: "",
      ID: 56,
    },
    NFT_NAME: "",
    SYMBOL: "",
    MAX_SUPPLY: 1,
    WEI_COST: 0,
    DISPLAY_COST: 0,
    GAS_LIMIT: 0,
    MARKETPLACE: "",
    MARKETPLACE_LINK: "",
    SHOW_BACKGROUND: false,
  });
  useEffect(() => {
    dispatch(connectM());
  }, []);

  useEffect(() => {
    setTimeout(() => {
      hasApproved ? dispatch(connect()) : dispatch(connectM());
    }, 3000);
  }, []);

  const getConfig = async () => {
    const configResponse = await fetch("/stakeConfig/config.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
    const config = await configResponse.json();
    SET_CONFIG(config);
  };
  const getDataM = () => {
    if (account !== "" && blockchain.smartContract !== null) {
      dispatch(fetchDataM());
    }
  };
  const getData = () => {
    if (account !== "" && blockchain.smartContract !== null) {
      dispatch(fetchData());
    }
  };
  useEffect(() => {
    getConfig();
  }, []);
  useEffect(() => {
    getDataM();
    getData();
  }, [account]);

  const stake = (tokenId) => {
    setStaking(true);
    setFeedback("BUSY");
    dispatch(connect());
    blockchain.smartContract.methods
      .deposit([tokenId])
      .send({
        to: CONFIG.CONTRACT_ADDRESS,
        from: account,
      })
      .once("error", (err) => {
        console.log(err);
        setStaking(false);
      })
      .then((Response) => {
        setStaking(false);
      });

    setFeedback("STAKE");
  };

  const unStake = async (tokenId) => {
    setUnstaking(true);
    dispatch(connect());
    blockchain.smartContract.methods
      .withdraw([tokenId])
      .send({
        to: CONFIG.CONTRACT_ADDRESS,
        from: account,
      })
      .once("error", (err) => {
        console.log(err);
        setUnstaking(false);
      })
      .then((Response) => {
        setUnstaking(false);
      });
  };

  const unstakeAll = () => {
    setUnstaking(true);
    dispatch(connect());
    blockchain.smartContract.methods
      .withdraw()
      .send({
        to: CONFIG.CONTRACT_ADDRESS,
        from: account,
      })
      .once("error", (err) => {
        console.log(err);
        setUnstaking(false);
      })
      .then((Response) => {
        setUnstaking(false);
      });
  };

  const approve = async () => {
    dispatch(connectM());
    await blockchain.smartContract.methods
      .setApprovalForAll(CONFIG.CONTRACT_ADDRESS, true)
      .send({
        to: CONFIG.CONTRACT_ADDRESS,
        from: account,
      });
    dispatch(connect());
  };

  const claim = async (tokenId) => {
    setClaiming(true);
    dispatch(connect());
    await blockchain.smartContract.methods
      .claimRewards()
      .send({
        to: CONFIG.CONTRACT_ADDRESS,
        from: account,
      })
      .once("error", (err) => {
        console.log(err);
        setClaiming(false);
      })
      .then((Response) => {
        setClaiming(false);
      });
  };
  const handleChange = (e) => {
    e.preventDefault();
    setTokenId(parseInt(e.target.value.split(" ")));
  };
  async function rewardinfo() {
    var rawnfts = await blockchain.smartContract.methods
      .depositsOf(account)
      .call();
    const arraynft = Array.from(rawnfts.map(Number));
    const tokenid = arraynft.filter(Number);
    var rwdArray = [];
    tokenid.forEach(async (id) => {
      var rawearn = await blockchain.smartContract.methods
        .calculateRewards(account, [id])
        .call();
      var array = Array.from(rawearn.map(Number));
      array.forEach(async (item) => {
        var earned = String(item).split(",")[0];
        var earnedrwd = earned;
        var rewardx = Number(earnedrwd).toFixed(18);
        var numrwd = Number(rewardx);
        rwdArray.push(numrwd);
      });
    });
    function delay() {
      return new Promise((resolve) => setTimeout(resolve, 300));
    }
    async function delayedLog(item) {
      await delay();
      var sum = item.reduce((a, b) => a + b, 0);
      var formatsum = Number(sum).toFixed(18);
      document.getElementById("earned").textContent =
        formatsum / 1000000000000000000;
    }
    async function processArray(rwdArray) {
      for (const item of rwdArray) {
        await delayedLog(item);
      }
    }
    return processArray([rwdArray]);
  }
  async function claimit() {
    var rawnfts = await blockchain.smartContract.methods
      .depositsOf(account)
      .call();
    const arraynft = Array.from(rawnfts.map(Number));
    const tokenid = arraynft.filter(Number);

    tokenid.forEach(async (id) => {
      await blockchain.smartContract.methods.claimRewards([id]).send({
        to: CONFIG.CONTRACT_ADDRESS,
        from: account,
      });
    });
  }

  async function unstakeall() {
    var rawnfts = await blockchain.smartContract.methods
      .depositsOf(account)
      .call();
    const arraynft = Array.from(rawnfts.map(Number));
    const tokenid = arraynft.filter(Number);

    tokenid.forEach(async (id) => {
      await blockchain.smartContract.methods.withdraw([id]).send({
        to: CONFIG.CONTRACT_ADDRESS,
        from: account,
      });
    });
  }

  async function enable() {
    blockchain.smartContract.methods
      .setApprovalForAll(CONFIG.CONTRACT_ADDRESS, true)
      .send({ from: account });
  }

  return (
    <main className="stake-app">
      <h1 style={{ color: "#ff5722" }}></h1>
      <h2 style={{ color: "#ff5722" }}></h2>
      <h2 style={{ color: "#ff5722" }}></h2>

      <h2>
        {staking ? "staking.." : ""}
        {unstaking ? "unstaking.." : ""}
        {claiming ? "claiming.." : ""}
      </h2>
      {/* <button 
                className="connect-btn"
                onClick={(e)=>{
                    !isConnected ?
                    dispatch(connectM())
                    : e.preventDefault()
                } }
            >
                {!isConnected ? "CONNECT WALLET" : account.slice(0, 10)}
            </button> */}
      <div className="card-container">
        <div>
          <blockquote className="reward">
            <span>Total Staked NFTs</span> ⚔️ {totalStakeNFTS} ⚔️
          </blockquote>
          <blockquote className="reward">
            <span>Your NFTs Staked</span> ⚔️ {stakedNFTS + "  "} ⚔️
          </blockquote>

          <button className="reward" onClick={rewardinfo}>
            💰 Click Here To Check Rewards 💰
          </button>
          <div id="earned">
            <div className="earnedTokens"></div>
          </div>
          <button className="reward" onClick={claimit}>
            🛡️ Claim All Rewards 🛡️
          </button>

          <form className="form" onChange={handleChange}>
            <input
              type="all"
              placeholder="Enter TokenId"
              className=""
              required
            />
            <button
              className="reward"
              onClick={
                hasApproved
                  ? (e) => {
                      e.preventDefault();
                      stake(tokenId);
                    }
                  : (e) => {
                      e.preventDefault();
                      approve(tokenId);
                    }
              }
            >
              {hasApproved ? "STAKE ✅" : "APPROVE ✅"}
            </button>
          </form>
          <form className="form" onChange={handleChange}>
            <input
              type="all"
              placeholder="Enter TokenId"
              className=""
              required
            />
            <button
              className="reward"
              onClick={(e) => {
                e.preventDefault();
                unStake(tokenId);
              }}
            >
              UNSTAKE ❌
            </button>
          </form>
          <button className="reward" onClick={unstakeall}>
            ❌ Unstake All ❌
          </button>
        </div>
      </div>
    </main>
  );
};

export default Staking;
